import React from 'react';

/** Empty-state illustration for joystick sessions. */
export function JoystickArt() {
  return (
    <svg className="js-art" viewBox="0 0 420 250" aria-hidden="true">
      <rect className="js-art__sky" width="420" height="250" rx="28" />
      <circle className="js-art__sun" cx="348" cy="46" r="16" />
      <ellipse className="js-art__cloud" cx="64" cy="52" rx="18" ry="10" />
      <ellipse className="js-art__cloud" cx="84" cy="46" rx="14" ry="9" />
      <path className="js-art__hill" d="M0 156c52-34 92 12 146-14 44-20 78 18 132-4 36-14 62 10 142-16v128H0z" />
      <path className="js-art__hill js-art__hill--front" d="M0 190c60-20 104 16 168 0 48-12 80 14 252-12v72H0z" />
      <rect className="js-art__map" x="78" y="62" width="196" height="132" rx="18" />
      <path className="js-art__road" d="M92 150h168M96 112h150M118 78v100M196 78v100" />
      <path className="js-art__route" d="M108 168c28-20 46-8 70-28 18-16 40-10 62-30" />
      <circle className="js-art__start" cx="108" cy="168" r="6" />
      <circle className="js-art__end" cx="240" cy="110" r="6" />
      <g transform="translate(268 96)">
        <rect className="js-art__pad" width="86" height="54" rx="22" />
        <circle cx="28" cy="28" r="8" fill="#fff" />
        <circle cx="58" cy="20" r="5" fill="#fff" />
        <circle cx="66" cy="34" r="5" fill="var(--ml-accent-soft, #ffe08a)" />
        <path d="M34 0c4-16 16-16 20 0" fill="none" stroke="var(--ml-primary, #7c5cff)" strokeWidth="5" strokeLinecap="round" />
      </g>
    </svg>
  );
}

export default JoystickArt;
